import { useCallback } from "react";

import type { MonitorAndProtectModelTrademarksTrademarkModel } from "@similarweb/pro-api-client";

import { mnpTrademarkNavigation } from "../../app/navigation";
import { useMonitorAndProtectCampaigns } from "../../services/api/campaign";

import { useMonitorAndProtectTrademarkDataAndParams } from "./trademark-params";

export const useSelectTrademark = () => {
    const { data: campaignList = [] } = useMonitorAndProtectCampaigns();
    const routeParams = useMonitorAndProtectTrademarkDataAndParams();

    const getQueryParams = useCallback(
        (trademark: MonitorAndProtectModelTrademarksTrademarkModel) => {
            const mutableRouteParams = { ...routeParams };
            for (const key in mutableRouteParams) {
                mutableRouteParams[key] = null;
            }

            // Collect all domains to match: primary domain + whitelisted domains
            const domainsToMatch = new Set([trademark.domain, ...(trademark.whiteListedDomains || [])]);

            const matchingCampaignIds = campaignList
                .filter((campaign) => domainsToMatch.has(campaign.domain))
                .map((campaign) => campaign.id)
                .slice(0, 10);

            return {
                ...mutableRouteParams,
                trademarkId: trademark.id,
                dataFilters: matchingCampaignIds.length > 0 ? { campaignsIds: matchingCampaignIds } : {},
            };
        },
        [campaignList, routeParams],
    );

    const selectTrademark = useCallback(
        (trademark: MonitorAndProtectModelTrademarksTrademarkModel) => {
            const queryParams = getQueryParams(trademark);

            void mnpTrademarkNavigation.updateQueryParams(queryParams);
        },
        [getQueryParams],
    );

    const selectTrademarkAndRedirect = useCallback(
        (trademark: MonitorAndProtectModelTrademarksTrademarkModel) => {
            const queryParams = getQueryParams(trademark);

            void mnpTrademarkNavigation.violations.go(queryParams);
        },
        [getQueryParams],
    );

    return { selectTrademark, selectTrademarkAndRedirect };
};
